// src/pages/responseCodes.js
// Mapping : code RB (exactement 3 chiffres) -> message terminal en français
export const RESPONSE_CODE_MAP = {
 "000": "Approuvé",
  "001": "Approuvé",
  "002": "Approuvé",
  "003": "Approuvé",
  "004": "Approuvé",
  "005": "Erreur Système",
  "007": "Approuvé",
  "008": "Approuvé",
  "009": "Approuvé",
  "023": "Approuvé",
  "024": "Approuvé",
  "025": "Approuvé",
  "026": "Approuvé",
  "027": "Approuvé",
  "028": "Approuvé",
  "029": "Réponse approuvée (duplication)",

  "050": "Réessayer — problème système",
  "051": "Carte expirée — contacter la succursale",
  "052": "Trop d'erreurs NIP",
  "053": "Non traitable",
  "054": "Réessayer — problème système",
  "055": "Carte non acceptée",
  "056": "Carte non acceptée",
  "057": "Usage restreint de carte",
  "058": "Usage restreint de carte",
  "059": "Usage restreint de carte",
  "060": "Type de compte non valide",
  "061": "Carte inactive",
  "062": "Réessayer — problème système",
  "063": "Réessayer — problème système",
  "064": "Numéro de carte non valide",
  "065": "Limite magasin dépassée",
  "066": "Réessayer — problème système",
  "067": "Date de transaction invalide",
  "068": "Erreur PTLF",
  "069": "Erreur — message invalide",
  "070": "Carte non valide — contacter la succursale",
  "071": "Carte non valide — contacter la succursale",
  "072": "Réessayer — problème système",
  "073": "Carte non valide — contacter la succursale",
  "074": "Émetteur non relié",
  "075": "Numéro de carte non valide",
  "076": "Fonds insuffisants",
  "077": "Limite dépassée — contacter la succursale",
  "078": "Transaction dupliquée",
  "079": "Nombre maximum de remboursements en ligne atteint",
  "080": "Nombre maximum de remboursements hors ligne atteint",
  "081": "Crédit maximum par remboursement atteint",
  "082": "Nombre d'utilisations dépassé",
  "083": "Crédit de remboursement maximum atteint",
  "084": "Réponse dupliquée / transaction en double",
  "085": "Demande non autorisée (inquiry not allowed)",
  "086": "Dépassement du plafond (over floor limit)",
  "087": "Nombre maximum de crédits de remboursement par commerçant atteint",
  "088": "Appeler le support",
  "089": "Usage carte restreint",
  "090": "Réessayer — problème système",
  "091": "Réessayer — problème système",
  "092": "Limite magasin dépassée",
  "093": "Réessayer — problème système",
  "094": "Réessayer — problème système",
  "095": "Montant dépassant le maximum",
  "096": "NIP erroné",
  "097": "Numéro de carte non valide",
  "098": "Réessayer — problème système",
  "099": "Numéro de carte non valide",

  "100": "Réessayer — problème système",
  "101": "Réessayer — problème système",
  "102": "Réessayer — problème système",
  "103": "Réessayer — problème système",
  "104": "Réessayer — problème système",
  "105": "Carte non valide",
  "106": "Montant dépassant le maximum",
  "107": "Dépassement du plafond journalier",
  "108": "Problème CAF",
  "109": "Avance inférieure au minimum",
  "110": "Nombre d'utilisations dépassé",
  "111": "Compte en souffrance (delinquent)",
  "112": "Dépassement table limite",
  "113": "Réessayer — problème système",
  "115": "Erreur PTLF",
  "121": "Problème fichier d'administration",
  "122": "Impossible de valider le NIP : module de sécurité indisponible",

  "150": "Code service / commerçant invalide",
  "200": "Compte invalide",
  "201": "NIP incorrect / blocage NIP",
  "202": "Avance inférieure au minimum",
  "203": "Carte administrative requise",
  "204": "Montant dépassant le maximum",
  "205": "Montant anticipé invalide",
  "206": "Compte invalide",
  "207": "Date de transaction invalide",
  "208": "Date d'expiration invalide",
  "209": "Code de transaction invalide",
  "210": "Erreur de synchronisation clé NIP",
  "212": "Destination non disponible",
  "251": "Erreur sur montant espèces",
  "252": "Débit non pris en charge",

  "408": "Carte crédit — usage limité, voir succursale",
  "416": "Carte refusée",
  "421": "Carte refusée",
  "422": "Carte refusée — ne pas réessayer",
  "423": "Refusée — vérification échouée",

  "426": "Appeler AMEX",
  "427": "Commerçant inconnu",
  "429": "Problème de compte — réessayer",
  "430": "Carte expirée",
  "431": "Appeler AMEX",
  "434": "Appeler AMEX (03)",
  "435": "AMEX — système en panne",
  "436": "Appeler AMEX (05)",
  "437": "Refusée",
  "438": "Refusée — service",
  "439": "Erreur de service",
  "440": "Appeler AMEX",
  "441": "Montant incorrect — réessayer",

  "475": "Refusée — date d'expiration invalide",
  "476": "Refusée",
  "477": "Refusée — compte inconnu",
  "478": "Refusée — conserver la carte (appeler)",
  "479": "Refusée — conserver la carte",
  "480": "Refusée — appeler",
  "481": "Refusée",
  "482": "Refusée — carte expirée",
  "483": "Refusée — référer l'appel à l'émetteur",
  "484": "Refusée — carte expirée",
  "485": "Non autorisé",
  "486": "Erreur cryptographique CVV",
  "487": "CVV invalide",
  "489": "CVV invalide",
  "490": "CVV invalide",
  "492": "Refusée — insérer la carte SVP",
  "493": "Refusée — réessayer dans 1 heure",
  "494": "Refusée — réessayer dans 24 heures",
  "495": "Refusée — réessayer dans 2 jours",
  "496": "Refusée — réessayer dans 4 jours",
  "497": "Refusée — réessayer dans 6 jours",
  "498": "Refusée — réessayer dans 8 jours",
  "499": "Refusée — réessayer dans 10 jours",

  "800": "Non traitable — recommencez svp",
  "801": "Non traitable — recommencez svp",
  "802": "Commis non valide",
  "809": "Opération non permise — réessayer",
  "810": "Délai dépassé — réessayer",
  "811": "Réessayer — problème système",
  "821": "Erreur d'édition — réessayer",
  "877": "Bloc NIP invalide",
  "878": "Erreur longueur NIP",
  "880": "Dernier paquet d'une transaction multi-paquet",
  "881": "Paquet intermédiaire d'une transaction multi-paquet",
  "889": "Erreur synchronisation clé MAC",
  "898": "Valeur MAC invalide",
  "899": "Numéro de séquence incorrect — renvoyer la transaction",

  "900": "Tentatives NIP dépassées",
  "901": "Carte expirée",
  "902": "Capture — NEG",
  "903": "Capture — statut CAF 3",
  "904": "Capture — avance inférieure au minimum",
  "905": "Capture — nombre d'utilisations dépassé",
  "906": "Capture — compte en souffrance",
  "907": "Capture — dépassement table limite",
  "908": "Capture — montant au-dessus du maximum",
  "909": "Carte restreinte",
  "950": "Carte d'administration non activée sur le profil commerçant",

  "960": "Échec d'initialisation — aucun match sur l'ID commerçant",
  "961": "Échec d'initialisation — aucun match sur l'ID PED",
  "962": "Échec d'initialisation — aucun match sur l'ID imprimante",
  "963": "Aucun match sur le code de sondage",
  "964": "Échec d'initialisation — aucun match sur l'ID concentrateur",
  "965": "Numéro de version logicielle invalide",
  "966": "Nom de terminal en doublon",
  "970": "Table terminal/caissier pleine",
  "983": "Totaux caissier indisponibles",
  "989": "Erreur MAC sur transaction 95",
  "990": "Carte à puce refuse une transaction approuvée par l'hôte",
  "991": "Carte à puce retirée avant la fin des communications ICC"
};

/**
 * Retourne le message en français **uniquement** si rawCode est exactement 3 chiffres (ex: "050").
 * Sinon retourne null.
 * @param {string|number} rawCode
 * @returns {string|null}
 */
export function getFrenchMessageForCode(rawCode) {
  if (!rawCode && rawCode !== 0) return null;
  const s = String(rawCode).trim();
  if (!/^\d{3}$/.test(s)) return null;
  return RESPONSE_CODE_MAP[s] || null;
}

/**
 * Si rawCode est exactement 3 chiffres, retourne "CCC - message".
 * Sinon retourne la valeur brute (ex: "P-48" ou "48") — sans motif.
 * @param {string|number} rawCode
 * @returns {string}
 */
export function formatCodeWithFrench(rawCode) {
  if (rawCode === null || rawCode === undefined || rawCode === '') return '—';
  const s = String(rawCode).trim();
  if (!/^\d{3}$/.test(s)) return s; // règle stricte : 3 chiffres exacts uniquement
  const msg = RESPONSE_CODE_MAP[s] || '—';
  return `${s} - ${msg}`;
}

/**
 * Normalise un code numérique vers la clé 3 chiffres du RESPONSE_CODE_MAP.
 * @param {string} part
 * @returns {string|null}
 */
function toMapKey(part) {
  const t = String(part).trim();
  if (!/^\d+$/.test(t)) return null;
  return t.padStart(3, '0');
}

/**
 * Overrides pour les badges du dashboard (Critique / Warn / Info).
 * Les autres codes numériques connus dans le map retombent sur une heuristique.
 */
export const RESPONSE_CODE_SEVERITY_OVERRIDES = {
  '005': 'err',
  '076': 'err',
  '900': 'err',
  '800': 'err',
  '811': 'warn',
  '810': 'warn',
  '096': 'warn',
  '050': 'warn',
  '074': 'warn',
  '107': 'warn',
  '205': 'info',
  'N/A': 'info',
};

/**
 * Description pour le tableau des codes retour du dashboard (API metrics).
 * Utilise RESPONSE_CODE_MAP ; gère N/A et codes composés "900/800".
 * @param {string|number|null|undefined} rawCode
 * @returns {string}
 */
export function getResponseCodeDescriptionForDashboard(rawCode) {
  if (rawCode === null || rawCode === undefined || rawCode === '') return '—';
  const s = String(rawCode).trim();
  if (s.toUpperCase() === 'N/A') return 'Annulé / Indisponible (sans code retour)';
  if (s.includes('/')) {
    return s
      .split('/')
      .map((p) => p.trim())
      .filter(Boolean)
      .map((p) => {
        const key = toMapKey(p);
        if (key && RESPONSE_CODE_MAP[key]) return RESPONSE_CODE_MAP[key];
        return p;
      })
      .join(' · ');
  }
  const key = toMapKey(s);
  if (key && RESPONSE_CODE_MAP[key]) return RESPONSE_CODE_MAP[key];
  if (/^\d+$/.test(s)) return `Code ${s.padStart(3, '0')}`;
  return s;
}

function severityForSingleToken(token) {
  const up = String(token).trim().toUpperCase();
  if (up === 'N/A') return RESPONSE_CODE_SEVERITY_OVERRIDES['N/A'] ?? 'info';
  const key = toMapKey(token);
  if (key && RESPONSE_CODE_SEVERITY_OVERRIDES[key]) return RESPONSE_CODE_SEVERITY_OVERRIDES[key];
  if (key && RESPONSE_CODE_MAP[key]) return 'warn';
  return 'info';
}

/**
 * Type de badge dashboard : err | warn | info
 * @param {string|number|null|undefined} rawCode
 * @returns {'err'|'warn'|'info'}
 */
export function getResponseCodeSeverityForDashboard(rawCode) {
  if (rawCode === null || rawCode === undefined || rawCode === '') return 'info';
  const s = String(rawCode).trim();
  if (s.toUpperCase() === 'N/A') return RESPONSE_CODE_SEVERITY_OVERRIDES['N/A'] ?? 'info';
  if (s.includes('/')) {
    const parts = s.split('/').map((p) => p.trim()).filter(Boolean);
    const levels = parts.map(severityForSingleToken);
    if (levels.includes('err')) return 'err';
    if (levels.includes('warn')) return 'warn';
    return 'info';
  }
  return severityForSingleToken(s);
}
